// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"422":"1f301e8d","753":"fe5e7786","987":"1c327244"}[chunkId] + ".chunk.css";
};